import { useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import layoutBgImg from '../../Images/layout/others.jpg'
import { useTranslation } from 'react-i18next'
import { Phone } from '@mui/icons-material'
import GlobalLayout from '../../Component/layout/global-layout'

const Forgot = () => {
  const { t } = useTranslation()
  const [phoneNumber, setPhoneNumber] = useState('+993');

  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;
    if (!input.startsWith('+993')) {
      input = '+993' + input.replace(/[^0-9]/g, '');
    } else {
      input = '+993' + input.slice(4).replace(/[^0-9]/g, '');
    }
    if (input.length > 12) {
      input = input.slice(0, 12);
    }
    setPhoneNumber(input);
  };

  const handleSubmit = () => {
    if (!phoneNumber) {
      alert(t('Meýdançany doldyrmak hökmany!'));
    } else {
      alert('Üstünlikli ugradyldy!');
    }
  };

  return (
    <GlobalLayout
      title={`${t('forgot')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords=""
    >
      <div className='mb-20'>
        <Layout
          title={t('forgot')}
          layoutBgImg={layoutBgImg}
        />
        <div className='flex justify-center w-full'>
          <div className='bg-white xl:p-8 mt-8 xl:w-[40%]
                        dark:bg-dark-box w-[90%] p-4'>
            <h1 className='text-center font-bold 
                        dark:text-white mb-1 text-4xl'>
              {t('forgot')}
            </h1>

            {/* phone */}
            <div className="relative mt-6">
              <label className='flex items-center gap-1 text-sm
                              dark:text-dark-text'>
                <Phone style={{ fontSize: '18px', color: '#0039a6' }} />
                {t('phone_number')}
              </label>
              <input
                type="text"
                name="phone"
                placeholder={t('phone_number')}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                className="w-full px-4 py-2 border dark:text-dark-text
                         border-border bg-secondary mb-2 mt-1 rounded
                       focus:outline-none focus:ring-2   focus:ring-indigo-500                        
                         dark:bg-dark-box dark:border-dark-border"
              />
            </div>

            <button
              type="button"
              className='text-white bg-primary px-6 
                         mt-6 py-2 rounded w-full'
              onClick={handleSubmit}
            >
              {t('verify_send')}
            </button>
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default Forgot